import { useSelector } from "react-redux";
import RoleListByType from "./Components/RoleListByType/UnitListByType";
import styles from "./UnitListManagement.module.scss";
const UnitListManagement = () => {
  const user = useSelector((state) => state.user.data);
  const roles = user?.role?.reduce((acc, item) => {
    const typeKey = item.type;
    let group = acc.find((g) => g.type === typeKey);
    if (!group) {
      group = { type: typeKey, data: [] };
      acc.push(group);
    }
    group.data.push(item);
    return acc;
  }, []);
  return (
    <div className={styles["role-list-management"]}>
      {roles?.map((role, index) => {
        return <RoleListByType roles={role} key={index} />;
      })}
    </div>
  );
};

export default UnitListManagement;
